// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__1zEPV","icon":"style_icon__3tFvj","title":"style_title__1OA1F","logo":"style_logo__YT-mT","logoContainer":"style_logoContainer__2UEAY"};